module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product.type == _vm.$const.PRODUCT_TYPES.STOCK) ? _c('div', {
    staticClass: "product-choice"
  }, _vm._l((_vm.product.stockAttributes), function(attr) {
    return _c('div', {
      staticClass: "specific",
      class: ("-" + (attr.key))
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("Choose your " + _vm._s(attr.key) + ": "), _c('span', {
      staticClass: "selected"
    }, [_vm._v(_vm._s(_vm.choices[attr.key] || '-'))])]), _vm._v(" "), _c('ul', {
      staticClass: "choice"
    }, _vm._l((attr.attributes), function(choice) {
      return _c('li', {
        staticClass: "item"
      }, [_c('button', {
        staticClass: "option",
        class: _vm.choiceClasses(attr.key, choice),
        on: {
          "click": function($event) {
            return _vm.choose(attr.key, choice)
          }
        }
      }, [_vm._v(_vm._s(choice))]), _vm._v("\n           \n        ")])
    }), 0)])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd1073f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductChoice.vue
// module id = 1194
// module chunks = 0